module.exports = __webpack_public_path__ + "img/Menu-02.71683800.png";